import React, { useEffect, useState } from "react";
import axios from "axios";
import { IncidentCard } from "./IncidentCard";
import { focusIncident } from "../lib/focusIncident";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Timeline = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/incidents?sort=date_desc`)
      .then((r) => {
        setItems(r.data);
        const target = new URLSearchParams(window.location.search).get("incident");
        if (target) setTimeout(() => focusIncident(target), 300);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="timeline" className="py-20 relative" data-testid="timeline-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <header className="mb-12 flex items-end justify-between flex-wrap gap-4">
          <div>
            <span className="font-mono text-xs uppercase text-[#FFEA00]">
              Chapter 01 · Receipts
            </span>
            <h2 className="heading text-5xl md:text-7xl leading-[0.9] mt-2">
              THE <span className="bg-[#FF003C] text-white px-2">TIMELINE</span> OF
              <br />
              QUESTIONABLE DECISIONS
            </h2>
          </div>
          <p className="max-w-sm text-sm text-white/70">
            A reverse-chronological crime scene. Freshest nonsense first.
          </p>
        </header>

        {loading ? (
          <div className="font-mono text-white/60">LOADING THE EVIDENCE...</div>
        ) : (
          <div className="relative">
            {/* center spine on md+ */}
            <div
              className="hidden md:block absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-1 caution-tape-red"
              aria-hidden
            />
            <ul className="space-y-10 md:space-y-16">
              {items.map((it, i) => {
                const leftSide = i % 2 === 0;
                return (
                  <li
                    key={it.id}
                    className="relative md:grid md:grid-cols-2 md:gap-10 items-start"
                  >
                    {/* date pill on center spine */}
                    <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 top-6 z-10">
                      <span
                        className="font-mono text-[11px] px-2 py-1 bg-black text-[#FFEA00] brutal-border"
                        style={{ borderWidth: 3 }}
                      >
                        {it.date}
                      </span>
                    </div>
                    <div className={leftSide ? "md:pr-10" : "md:col-start-2 md:pl-10"}>
                      <IncidentCard incident={it} index={i} anchor />
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    </section>
  );
};
